<ng-container *ngIf="control.errors &&(control.touched|| formDirective.submitted)">
  <span class="text-xs">
    {{errorMessages|validation:control.errors}}
  </span>
</ng-container>
